let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3FRk3")).then(() => parcelRequire('1LfPZ'));